module.exports = __webpack_public_path__ + "img/znhw.64296a68.png";